// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"7bc7dcf661df1f2b","6236":"6d9e69ba04fe35bd"}[chunkId] + ".css";
};